import React from 'react';
import ContentPerformanceFiguresHeader from './ContentPerformanceFiguresHeader';

const PerformanceHeader = () => (
  <div className="d-f jc-e pb-16 bb-gray-lighter" style={{ marginTop: '-4em' }}>
    <ContentPerformanceFiguresHeader />
  </div>
);

export default PerformanceHeader;
